import { DialogActions, DialogContent } from "@mui/material";
import { Button, PageHeader } from "common";
import WaiverPreview from "features/waivers/WaiverPreview";
import I18n from "i18n-js";
import useSubmitForm, { UseSubmitFormProps } from "./useSubmitForm";
export interface SubmitFormProps extends UseSubmitFormProps {}

export default function SubmitForm({
  id,
  afterSave,
  onClose,
  listItem,
}: SubmitFormProps) {
  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = useSubmitForm({
    id,
    afterSave,
  });

  const title = isCreate
    ? I18n.t("Submit.addTitle")
    : I18n.t("Submit.editTitle");
  return (
    <>
      <PageHeader title={title} onClose={onClose} />
      <DialogContent>
        <WaiverPreview item={item as any} />
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("App.save")}
          disabled={!isDirty}
          onClick={() => save()}
          loading={saving}
        />
      </DialogActions>
    </>
  );
}
